/**
 * 브랜드 상수 — **단일 소스.** DOM/Workers 어느 런타임에서도 import 할 수 있도록
 * 여기(=플랫폼 비의존 패키지)에 둔다.
 *
 * 왜 `@repo/ui/brand` 가 아닌가: `packages/ui/src/lib/brand.ts` 는 `window` 를 참조하므로
 * Workers 타입 프로젝트(`apps/stream-control/worker`)에서 import 하면 타입 에러가 난다.
 * 그래서 상수만 떼어 두고, `@repo/ui/brand` 는 여기서 재수출한다.
 * 브랜드 문자열을 두 곳에 복제하면 도메인 전환 때 한쪽만 바뀌는 사고가 난다
 * (docs/yoy-live-domain-migration.md §4.2).
 */

/** 정규 도메인. 표기 라벨과 동일하다(소문자 워드마크). */
export const BRAND_DOMAIN = 'yoy.live';

/** 마케팅 카피·UI 에 노출되는 표기. 전부 소문자로 통일한다. */
export const BRAND_LABEL = 'yoy.live';

/** 약관·개인정보처리방침·PDF 메타데이터에 들어가는 법인 표기(법정 기재사항). */
export const BRAND_COMPANY_NAMES = { ko: '주식회사 요이라이브', en: 'Yoylive Inc.' } as const;

/**
 * 이 서비스가 앱을 서빙하는 존(=apex) 전체 목록. staging 포함.
 *
 * Phase 5(2026-07) 에서 구 두 존(enter.fun / aether-fun.xyz)의 Worker 라우트를
 * 제거했다. 이제 그 호스트는 Cloudflare Redirect Rules 가 엣지에서 301 로
 * 넘기므로 **Worker 에 도달하지 않는다** — 따라서 목록에서 뺀다.
 *
 * production 존만이 아니라 **staging 존도 반드시 들어가야 한다** —
 * `enter-dot-fun.dev-unopnd.xyz` 는 라벨이 3개인 apex 이므로, 라벨 개수로
 * apex 를 판정하면 선두 라벨을 지워 보유하지 않은 도메인을 만든다.
 */
export const APP_ZONES = ['yoy.live', 'enter-dot-fun.dev-unopnd.xyz'] as const;

/** production 존 (staging 제외) — API 오리진 판정용. */
export const PRODUCTION_ZONES = ['yoy.live'] as const;

/** staging 존 = APP_ZONES − PRODUCTION_ZONES. 목록을 두 번 적지 않는다. */
export const STAGING_ZONES = APP_ZONES.filter(
  (z) => !(PRODUCTION_ZONES as readonly string[]).includes(z)
);

/** 공개 마케팅 문구(초대 미리보기 등에 공유된다). */
export const BRAND_TAGLINE = '게임 캠페인에 참여하고 방송으로 수익을 만드세요.';
